// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab___Abk4x","title":"title___mZQi-","active":"active___izB5R","titleContent":"titleContent___bgkVX"};